import { connect } from "react-redux";
import { ProgressBar } from "primereact/progressbar";

import { EzToast, TOAST_SEVERITY } from "../../../../common/EzToast";
import {
  initCreateReservationsDailyManifestReportScreen,
  createReservationsDailyManifestReport,
  editReservationsDailyManifestReport,
  fetchReservationsDailyManifestReportById,
  uploadImage,
} from "../../../../redux/actions/Reservations/ReservationsDailyManifestReport";
import {
  fetchLocationDD
} from "../../../../redux/actions/location";
import {
  fetchVehicleCategoryDD
} from "../../../../redux/actions/vehicles/vehicleCategory";
import { useEffect } from "react";
import { setIsformDirty } from "../../../../redux/actions/common/form";
import CreateReservationsDailyManifestReportComponent from "../../../../component/Reservations/ReservationsDailyManifestReport/CreateReservationsDailyManifestReport";
import { useParams } from "react-router-dom";

const CreateReservationsDailyManifestReportContainer = (props) => {
  console.log("checkprops on screen ", props);
  const {
    history,
    createReservationsDailyManifestReport,
    editReservationsDailyManifestReport,
    isLoading,
    isReservationsDailyManifestReportCreateSuccess,
    isReservationsDailyManifestReportCreateError,
    isReservationsDailyManifestReportDetailSuccess,
    isReservationsDailyManifestReportDetailError,
    isReservationsDailyManifestReportEditSuccess,
    isReservationsDailyManifestReportEditError,
    isEdit,
    isView,
    initCreateReservationsDailyManifestReportScreen,
    formFieldValueMap,
    fetchReservationsDailyManifestReportById,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
    shouldBlockNavigation,
        isVehicleModelDDSuccess,
        isVehicleModelDDError,
        fetchLocationDD,
        locationDD,
        fetchVehicleCategoryDD,
vehicleCategoryDD,
  } = props;

  const { id } = useParams
  ();
  const callAPIasync = async() =>{
    initCreateReservationsDailyManifestReportScreen();
    await fetchLocationDD();
    await fetchVehicleCategoryDD();
   if (isEdit) {
    await fetchReservationsDailyManifestReportById({id:id});
  }
  }
  useEffect(() => {
    callAPIasync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit]);

 

  const createReservationsDailyManifestReportProps = {
    createReservationsDailyManifestReport,
    initCreateReservationsDailyManifestReportScreen,
    editReservationsDailyManifestReport,
    isLoading,
    isEdit,
    isReservationsDailyManifestReportDetailSuccess,
    isReservationsDailyManifestReportCreateSuccess,
    isReservationsDailyManifestReportEditSuccess,
    isReservationsDailyManifestReportEditError,
    formFieldValueMap,
    shouldBlockNavigation,
    uploadImage,
    imageUploadResponse,
    isUploadImageSuccess,
    isUploadImageError,
        isVehicleModelDDSuccess,
        isVehicleModelDDError,
        locationDD,
        vehicleCategoryDD,
  };
  const getToastProps = () => {
    if (isReservationsDailyManifestReportCreateSuccess || isReservationsDailyManifestReportEditSuccess) {
      const toastTitle = isEdit
        ? "Daily Manifest Report Updated Successfully"
        : "Daily Manifest Report Created Successfully";
      return {
        severity: TOAST_SEVERITY.SUCCESS,
        toastTitle,
        shouldShowToast: true,
      };
    }

    if (
      isReservationsDailyManifestReportCreateError ||
      isReservationsDailyManifestReportDetailError ||
      isReservationsDailyManifestReportEditError
    ) {
      let toastTitle = "Error while Creating Reservations";
      if (isReservationsDailyManifestReportEditError) {
        toastTitle = "Error while updating  Reservations";
      } else if (isReservationsDailyManifestReportDetailError) {
        toastTitle =
          "Error while performing operation. Please refresh your browser";
      }

      return {
        severity: TOAST_SEVERITY.ERROR,
        toastTitle,
        shouldShowToast: true,
      };
    }
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  return (
    <>
      {isLoading && renderProgressBar()}
      <EzToast {...getToastProps()} />
      <CreateReservationsDailyManifestReportComponent {...createReservationsDailyManifestReportProps} />;
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  console.log("mapState", state);
  return {
    isLoading: selectFromReservationsDailyManifestReportReducer(state, "isLoading"),
   
    isReservationsDailyManifestReportCreateSuccess: selectFromReservationsDailyManifestReportReducer(
      state,
      "isReservationsDailyManifestReportCreateSuccess"
    ),
    isReservationsDailyManifestReportCreateError: selectFromReservationsDailyManifestReportReducer(
      state,
      "isReservationsDailyManifestReportCreateError"
    ),
    isReservationsDailyManifestReportDetailSuccess: selectFromReservationsDailyManifestReportReducer(
      state,
      "isReservationsDailyManifestReportDetailSuccess"
    ),
    isReservationsDailyManifestReportDetailError: selectFromReservationsDailyManifestReportReducer(
      state,
      "isReservationsDailyManifestReportDetailError"
    ),
    isReservationsDailyManifestReportEditSuccess: selectFromReservationsDailyManifestReportReducer(
      state,
      "isReservationsDailyManifestReportEditSuccess"
    ),
    isReservationsDailyManifestReportEditError: selectFromReservationsDailyManifestReportReducer(
      state,
      "isReservationsDailyManifestReportEditError"
    ),
    imageUploadResponse: selectFromReservationsDailyManifestReportReducer(
      state,
      "imageUploadResponse"
    ),
    isUploadImageSuccess: selectFromReservationsDailyManifestReportReducer(
      state,
      "isUploadImageSuccess"
    ),
    isUploadImageError: selectFromReservationsDailyManifestReportReducer(
      state,
      "isUploadImageError"
    ),


    vehicleModelDD: selectFromReservationsDailyManifestReportReducer(
      state,
      "vehicleModelDD"
    ),
    isVehicleModelDDSuccess: selectFromReservationsDailyManifestReportReducer(
      state,
      "isVehicleModelDDSuccess"
    ),
    isVehicleModelDDError: selectFromReservationsDailyManifestReportReducer(
      state,
      "isVehicleModelDDError"
    ),
    locationDD: selectFromLocationReducer(
      state,
      "locationDD"
    ),
    vehicleCategoryDD: selectFromVehicleVehicleCategoryReducer(
      state,
      "vehicleCategoryDD"
    ),
    formFieldValueMap: selectFromReservationsDailyManifestReportReducer(state, "formFieldValueMap"),
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    initCreateReservationsDailyManifestReportScreen: () => dispatch(initCreateReservationsDailyManifestReportScreen()),
    createReservationsDailyManifestReport: (payload) => dispatch(createReservationsDailyManifestReport(payload)),
    editReservationsDailyManifestReport: (payload) => dispatch(editReservationsDailyManifestReport(payload)),
    shouldBlockNavigation: (isFormDirty) =>dispatch(setIsformDirty(isFormDirty)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    fetchVehicleCategoryDD: (payload) => dispatch(fetchVehicleCategoryDD(payload)),
    uploadImage:(payload) => dispatch(uploadImage(payload)),
    fetchReservationsDailyManifestReportById: (payload) =>
      dispatch(fetchReservationsDailyManifestReportById(payload)),

  };
};

const selectFromReservationsDailyManifestReportReducer = (state, path) => {
  return selectReservationsDailyManifestReportReducer(state)[path];
};

const selectReservationsDailyManifestReportReducer = ({ ReservationsDailyManifestReportReducer }) => {
  return ReservationsDailyManifestReportReducer;
};
//Location
const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};
//Category
const selectFromVehicleVehicleCategoryReducer = (state, path) => {
  return selectVehicleVehicleCategoryReducer(state)[path];
};
const selectVehicleVehicleCategoryReducer = ({ vehicleCategoryReducer }) => {
  return vehicleCategoryReducer;
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateReservationsDailyManifestReportContainer);
